export default __webpack_public_path__ + "static/media/Q5-3.7f0b5a6a.jpg";